module.exports = __webpack_public_path__ + "img/39.aa1390ca.jpg";